export enum ErrorCodesEnum {
  UNKNOWN = "E_UNKNOWN",
  CONFLICT = "E_CONFLICT",
  BAD_REQUEST = "E_BAD_REQUEST",
  VALIDATION = "E_VALIDATION",
  EMAIL_CONFLICT = "E_EMAIL_CONFLICT",
  FORBIDDEN = "E_FORBIDDEN",
  INTERNAL_SERVER_ERROR = "E_INTERNAL_SERVER_ERROR",
  ENTITY_NOT_FOUND = "E_ENTITY_NOT_FOUND",
  NOT_FOUND = "E_NOT_FOUND",
  DEV_ERROR = "E_DEV_ERROR",
  QUERY_FAILURE = "E_QUERY_FAILURE",
}
